import { BaseComponentOption } from '@/scripts/Components/Utilities/DataProviderBaseComponent';
import urlLocationHelper from '@/scripts/helpers/url-location-helper';
import { ChannelCollectionImplementation } from '@/scripts/models/videoCollections/implementations/ChannelCollectionImplementation';
import { CollectionImplementation, CollectionImplementationData } from '@/scripts/models/videoCollections/implementations/core/BaseCollectionImplementation';
import { PlaylistCollectionImplementation } from '@/scripts/models/videoCollections/implementations/PlaylistCollectionImplementation';
import { SeriesCollectionImplementation } from '@/scripts/models/videoCollections/implementations/SeriesCollectionImplementation';
import { Model } from '@viddsee/server-api-client';
import { PropType } from 'vue';

export const findImplementation = (implementations: AcceptedImplementation[]): CollectionImplementation | null => {
  let selectedImplementation: CollectionImplementation | null = null;
  implementations.find(([ImplementationClass, implementationArguments]) => {
    const proposedImplementation = new ImplementationClass(implementationArguments[0]);
    if (!proposedImplementation.test()) {
      return false;
    }
    selectedImplementation = proposedImplementation;
    return true;
  });
  return selectedImplementation;
};

type CollectionImplementations = (
  typeof CollectionImplementation |
  typeof ChannelCollectionImplementation |
  typeof SeriesCollectionImplementation |
  typeof PlaylistCollectionImplementation
);
type AcceptedImplementation = [CollectionImplementations, any]

export default BaseComponentOption.extend({
  props: {
    video: {
      type: Object as PropType<Model.Video.Info>,
      required: true,
    },
  },
  data(): {
    implementations: AcceptedImplementation[];
    } {
    return {
      implementations: [
        [
          ChannelCollectionImplementation,
          [{ video: this.video }],
        ],
        [
          PlaylistCollectionImplementation,
          [{ video: this.video }],
        ],
        [
          SeriesCollectionImplementation,
          [
            {
              video: this.video,
              params: {
                series: this.video.seriesSnippet && this.video.seriesSnippet.slug,
                season: this.video.seriesSnippet && this.video.seriesSnippet.seasonSnippet.slug,
                ...urlLocationHelper.query.parse(),
              },
            },
          ],
        ],
      ],
    };
  },

  methods: {
    // return definition on how to fetch info data and videos data
    fetchData(): CollectionImplementationData | Promise<CollectionImplementationData | null> | null {
      const selectedImplementation = findImplementation(this.implementations);

      return Promise.resolve(
        selectedImplementation
          ? selectedImplementation.provide()
          : null,
      );
    },
  },
});
